const Companion = () => {
    return (
        <div className="container h-6 bg-red">
            Companion View
        </div>
    )
}

export default Companion